import React from "react";
import { Card, Alert } from "react-bootstrap";

export default function PMOrderDocumentsPage({ pmPurchaseOrderId }) {
  return (
    <Card>
      <Card.Header>
        <h6 className="mb-0">
          <i className="fas fa-file-alt me-2"></i>
          Order Documents
        </h6>
      </Card.Header>
      <Card.Body>
        <Alert variant="info" className="text-center py-5">
          <i className="fas fa-info-circle fa-3x mb-3"></i>
          <h5>Document Management Coming Soon</h5>
          <p className="mb-0">The document management feature for packaging material purchase orders is under development.</p>
        </Alert>
      </Card.Body>
    </Card>
  );
}
